module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('header', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "top_content"
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.activeIndex,
      "background-color": "#409eff",
      "text-color": "#fff",
      "active-text-color": "#ff8a23",
      "mode": "horizontal"
    }
  }, [_vm._l((_vm.navList), function(item) {
    return [(item.children == null || item.children.length == 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.index
      },
      on: {
        "click": function($event) {
          _vm.clickToRouter(item.uri)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('el-submenu', {
      attrs: {
        "index": item.index
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(subItem) {
      return _c('el-menu-item', {
        attrs: {
          "index": subItem.index
        },
        on: {
          "click": function($event) {
            _vm.clickToRouter(subItem.uri)
          }
        }
      }, [_vm._v(_vm._s(subItem.name))])
    })], 2)]
  })], 2)], 1)]), _vm._v(" "), _c('router-view', {
    staticClass: "content_body"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "#/"
    }
  }, [_c('img', {
    staticClass: "float:left;",
    attrs: {
      "src": require("../assets/images/logo_main.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff8a23",
      "font-size": "150%"
    }
  }, [_vm._v("广州市东控工程项目管理有限公司")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a7a49a3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/home.vue
// module id = 246
// module chunks = 2